import { FC } from "react";

import { LocationEditor } from "./editor";

export const Edit: FC = () => {
	return (
		<section>
			<LocationEditor />
		</section>
	);
};
